import {DemoContainer} from '@mui/x-date-pickers/internals/demo';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DateTimePicker} from '@mui/x-date-pickers/DateTimePicker';
import {renderTimeViewClock} from '@mui/x-date-pickers/timeViewRenderers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';

export default function DateTimePickerForm({field, label, ...props}) {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DemoContainer components={['DateTimePicker']}>
        <DateTimePicker
          {...field}
          label={label}
          onChange={date => field.onChange(date)}
          value={field.value || null}
          viewRenderers={{
            hours: renderTimeViewClock,
            minutes: renderTimeViewClock,
            seconds: renderTimeViewClock,
          }}
          {...props}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
